import { isDefined, isIsoDate } from "@perxis-auto/shared";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectFilterImmutableValues } from "./selectFilterImmutableValues.js";
const IS_VEHICLE_FIELD_REFERENCE_MAP = {
  type: false,
  availability: false,
  id: false,
  disabled: false,
  collection_id: false,
  acceptedPaymentMethods: false,
  // @ts-ignore
  benefits: false,
  brand: true,
  condition: false,
  dealerSpaceIds: false,
  description: false,
  drivetrain: true,
  engine: true,
  exterior: true,
  gearbox: true,
  interior: true,
  locations: true,
  logisticStatus: true,
  media: true,
  mileage: false,
  model: true,
  options: true,
  ownersCount: false,
  package: true,
  price: false,
  productionDate: false,
  sku: false,
  specificationsValues: true,
  tags: true,
  version: true,
  videos: false,
  vin: false,
  displayName: false
};
const selectFilterImmutableQueries = createAppSelector(selectFilterImmutableValues, (immutableValues) => {
  const q = [];
  const qMap = {};
  for (const [key, value] of Object.entries(immutableValues)) {
    if (!isDefined(key) || !isDefined(value)) {
      continue;
    }
    const resolvedValues = Array.isArray(value) ? value : [value];
    let query;
    if (IS_VEHICLE_FIELD_REFERENCE_MAP[key]) {
      query = `${key}.id in ['${resolvedValues.join(`', '`)}']`;
    } else if (isIsoDate(resolvedValues[0])) {
      query = `${key} in [Time.Time('${resolvedValues.join(`'), Time.Time('`)}')]`;
    } else {
      query = `${key} in [${resolvedValues.map((v) => typeof v === "string" ? `'${v}'` : v).join(", ")}]`;
    }
    q.push(query);
  }
  return { q, qMap };
});
export {
  selectFilterImmutableQueries
};
